<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import Regulatory from './regulatory';

export default {
  name: 'WSRegulatory',
  mixins: [Regulatory]
}
</script>
